<template>
  <div class="yggk">
    <div class="yggk_header">
      <div class="yggk_header_left">
        <h3>
          <label></label>员工信息
        </h3>
        <p>员工名称:{{username}}</p>
        <p>员工IP:{{ip}}</p>
        <p>上线时间:2020-02-18 15:45:20</p>
        <h3 style="margin-top:38px">
          <label></label>计算机信息
        </h3>
        <p>计算机名称:{{host_name}}</p>
        <p>操作系统:{{os_name}}</p>
      </div>
      <div class="yggk_header_center">
        <h3>
          <label></label>软件使用
        </h3>
        <div
          style="overflow: auto;height:calc(100% - 70px);margin-top:10px;display:flex;flex-direction: column; text-align: left;justify-content: stretch;"
        >
          <div v-for="item in rjList" v-bind:key="item.appName">
            {{item.appName}}
            <label>{{item.precent}}%</label>
          </div>
        </div>
      </div>
      <div class="yggk_header_right">
        <h3>
          <label></label>屏幕截图
        </h3>
        <div style="overflow: auto;height:calc(100% - 70px);margin-top:10px;">
          <p style="margin:0px 25px 0 25px; text-align:left;">
            <img :src="kpPic" width="100%" />
          </p>
        </div>
      </div>
    </div>
    <div class="yggk_footer">
      <h3>
        <label></label>当日概况
      </h3>
      <div style="margin:5px 25px 0px 25px;height:calc(100% - 50px)">
        <el-table
          :data="tableData"
          stripe
          style="width: 100%;"
          height="calc(100% - 10px)"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.3)"
        >
          <el-table-column prop="run_time" label="电脑运行时长"></el-table-column>
          <el-table-column prop="idle_time" label="空闲时长"></el-table-column>
          <el-table-column label="开机时间">
            <template slot-scope="scope">
              <p>{{ scope.row.start_time }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="chat_time" label="聊天时长"></el-table-column>
          <el-table-column prop="web_time" label="访问网页时长"></el-table-column>
          <el-table-column prop="web_count" label="网页数量"></el-table-column>
          <el-table-column prop="usb_count" label="U盘记录"></el-table-column>
          <el-table-column prop="warn_count" label="报警记录"></el-table-column>
          <el-table-column label="程序使用统计">
            <template slot-scope="scope">
              <div style="display:flex">
                <label style="margin-right:10px;">详情</label>
                <el-popover trigger="hover" placement="bottom">
                  <p
                    v-for="item in scope.row.software"
                    v-bind:key="item.appName"
                    style="margin-top:10px"
                  >
                    <span style="display:inline-block;width:40px;">{{ item.precent }}%</span>
                    {{ item.appName }}
                  </p>
                  <p>{{ scope.row.date }}</p>
                  <div
                    slot="reference"
                    class="name-wrapper"
                    v-on:mouseover="onScopeover(scope.row)"
                    v-on:mouseout="onScopeout(scope.row)"
                  >
                    <span
                      v-show="!scope.row.icon"
                      style="height:30px;width:30px;background-color:#E3E3E3;border-radius: 30px; line-height:30px ;text-align:center; display: inline-block;"
                    >
                      <i
                        class="el-icon-caret-right"
                        style="color:#2878FF;font-size:20px;margin-top:5px;"
                      ></i>
                    </span>
                    <span
                      v-show="scope.row.icon"
                      style="height:30px;width:30px;background-color:#E3E3E3;border-radius: 30px; line-height:30px ;text-align:center;display: inline-block;"
                    >
                      <i
                        class="el-icon-caret-bottom"
                        style="color:#2878FF;font-size:20px;margin-top:5px;"
                      ></i>
                    </span>
                  </div>
                </el-popover>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { http } from "./../../https";
export default {
  data() {
    return {
      tableData: [],
      rjList: [],
      username: "",
      ip: "",
      host_name: "",
      os_name: "",
      mac: "",
      loading: false,
      sessionUsername: "",
      sessionOwner: "",
      sessionMac: "",
      kpPic: ""
    };
  },
  created() {
    if (this.$route.query.name != null && this.$route.query.name != "") {
      const user_name = this.$route.query.name;
      const owner = this.$route.query.owner;
      const mac = this.$route.query.mac;
      const is_online = this.$route.query.is_online;
      this.sessionUsername = user_name;
      this.sessionOwner = owner;
      this.sessionMac = mac;
      let macSplit = mac.replace(/-/g, "");
      if (is_online == 0) {
        this.kpPic = "";
        this.rjList = [];
        this.tableData = [];
        this.pepleSz(user_name);
      } else {
        this.pepleSz(user_name);
        this.rjsyList(owner, macSplit);
        this.baobiaoList(owner, macSplit);
        this.jietuPic(owner, macSplit);
      }
    } else {
      let jsons = JSON.parse(sessionStorage.getItem("routeQuery"));
      const user_name = jsons.userName;
      const owner = jsons.owner;
      const mac = jsons.mac;
      const is_online = jsons.is_online;
      this.sessionUsername = user_name;
      this.sessionOwner = owner;
      this.sessionMac = mac;
      let macSplit = mac.replace(/-/g, "");
      if (is_online == 0) {
        this.kpPic = "";
        this.rjList = [];
        this.tableData = [];
        this.pepleSz(user_name);
      } else {
        this.pepleSz(user_name);
        this.rjsyList(owner, macSplit);
        this.baobiaoList(owner, macSplit);
        this.jietuPic(owner, macSplit);
      }
    }
  },
  destroyed() {
    sessionStorage.removeItem("routeQuery");
    let jsons = {
      userName: this.sessionUsername,
      owner: this.sessionOwner,
      mac: this.sessionMac
    };
    sessionStorage.setItem("routeQuery", JSON.stringify(jsons));
  },
  watch: {
    $route() {
      const user_name = this.$route.query.name;
      const owner = this.$route.query.owner;
      const mac = this.$route.query.mac;
      const is_online = this.$route.query.is_online;
      let macSplit = mac.replace(/-/g, "");
      this.sessionUsername = user_name;
      this.sessionOwner = owner;
      this.sessionMac = mac;
      if (is_online == 0) {
        this.kpPic = "";
        this.rjList = [];
        this.tableData = [];
        this.pepleSz(user_name);
      } else {
        this.pepleSz(user_name);
        this.rjsyList(owner, macSplit);
        this.baobiaoList(owner, macSplit);
        this.jietuPic(owner, macSplit);
      }
    }
  },
  methods: {
    pepleSz(e) {
      const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
      for (let ew of dataGroup.server) {
        if (ew.user_name == e) {
          this.username = ew.user_name;
          this.ip = ew.ip;
          this.host_name = ew.host_name;
          this.os_name = ew.os_name;
          this.mac = ew.mac;
        }
      }
    },
    rjsyList(user_name, macSplit) {
      let url = `http://${user_name}_${macSplit}.ng.360mon.cn:90/index.php?class=record&act=getSoftwareUseInfo`;
      http({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      })
        .then(res => {
          if (res.code == 0) {
            for (let s of res.data) {
              s.precent = parseInt(s.precent * 100);
            }
            this.rjList = res.data;
          } else {
            this.rjList = [];
          }
        })
        .catch(res => {
          this.rjList = [];
          console.log(res);
        });
    },
    jietuPic(user_name, macSplit) {
      let url = `http://${user_name}_${macSplit}.ng.360mon.cn:90/index.php?class=record&act=getRealScreen&quality=100&resolution=1280`;
      http({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      })
        .then(res => {
          if (res.code == 0) {
            this.kpPic = `http://${user_name}_${macSplit}.ng.360mon.cn:90/${res.data.img}`;
          } else {
            this.kpPic = "";
          }
        })
        .catch(res => {
          this.kpPic = "";
          console.log(res);
        });
    },
    baobiaoList(user_name, macSplit) {
      this.loading = true;
      var timeStamp = new Date(new Date().setHours(0, 0, 0, 0)) / 1000;
      let start_time = timeStamp;
      let url = `http://${user_name}_${macSplit}.ng.360mon.cn:90/index.php?class=record&act=generateReports&date=${start_time}`;
      http({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      })
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            this.loading = false;
            if (res.data instanceof Array) {
              for (let s of res.data) {
                s.data.run_time = this.formatSeconds(s.data.run_time);
                s.data.idle_time = this.formatSeconds(s.data.idle_time);
                s.data.chat_time = this.formatSeconds(s.data.chat_time);
                s.data.web_time = this.formatSeconds(s.data.web_time);
                s.data.start_time = this.timestampToTime(s.data.start_time);
                if (s.data.close_time != 0) {
                  s.data.close_time = this.timestampToTime(s.data.close_time);
                }
                for (let item of s.software) {
                  item.precent = parseInt(item.precent * 100);
                }
              }
              this.tableData = res.data;
            } else {
              this.tableData = [];
              res.data.run_time = this.formatSeconds(res.data.run_time);
              res.data.idle_time = this.formatSeconds(res.data.idle_time);
              res.data.chat_time = this.formatSeconds(res.data.chat_time);
              res.data.web_time = this.formatSeconds(res.data.web_time);
              res.data.start_time = this.timestampToTime(res.data.start_time);
              if (res.data.close_time != 0) {
                res.data.close_time = this.timestampToTime(res.data.close_time);
              }
              for (let item of res.data.software) {
                item.precent = parseInt(item.precent * 100);
              }
              this.tableData.push(res.data);
            }
          } else {
            this.tableData = [];
          }
        })
        .catch(res => {
          this.loading = false;
          this.tableData = [];
          console.log(res);
        });
    },
    formatSeconds(value) {
      var theTime = parseInt(value); // 秒
      var middle = 0; // 分
      var hour = 0; // 小时

      if (theTime > 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle > 60) {
          hour = parseInt(middle / 60);
          middle = parseInt(middle % 60);
        }
      }
      var result = "" + parseInt(theTime) + "秒";
      if (middle > 0) {
        result = "" + parseInt(middle) + "分" + result;
      }
      if (hour > 0) {
        result = "" + parseInt(hour) + "小时" + result;
      }
      return result;
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    }
  }
};
</script>
<style scoped>
.yggk_header {
  display: flex;
}
.yggk_header h3 {
  margin: 18px 25px 0 25px;
  font-size: 15px;
  font-weight: bold;
  text-align: left;
  color: rgba(70, 70, 70, 1);
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 10px;
}
.yggk_header h3 label {
  border-left: 5px solid #2878ff;
  margin-right: 6px;
}
.yggk_header .yggk_header_left {
  width: 30%;
  height: 334px;
  background: #ffffff;
  margin-right: 18px;
  border-radius: 8px;
}
.yggk_header .yggk_header_left p {
  margin: 5px 25px 0 25px;
  font-size: 13px;
  font-weight: 400;
  color: rgba(123, 123, 123, 1);
  line-height: 28px;
  text-align: left;
}
.yggk_header .yggk_header_center {
  width: 30%;
  height: 334px;
  background: #ffffff;
  margin-right: 18px;
  border-radius: 8px;
}
.yggk_header .yggk_header_center div {
  margin: 5px 10px 0 10px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 400;
  color: rgba(123, 123, 123, 1);
  line-height: 21px;
}
.yggk_header .yggk_header_right {
  width: 40%;
  height: 334px;
  background: #ffffff;
  border-radius: 8px;
}
.yggk_footer {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  margin-top: 21px;
  height: calc(100vh - 606px);
  border-radius: 8px;
}
.yggk_footer h3 {
  margin: 18px 25px 0 25px;
  font-size: 15px;
  font-weight: bold;
  text-align: left;
  color: rgba(70, 70, 70, 1);
}
.yggk_footer h3 label {
  border-left: 5px solid #2878ff;
  margin-right: 6px;
}

.yggk /deep/.el-table {
  margin-top: 10px;
  text-align: center;
}
.yggk /deep/.el-table th {
  background: #e9e9e9;
  font-size: 15px;
  font-weight: bold;
  color: rgba(17, 17, 17, 1);
}
.yggk /deep/.el-table th,
.yggk /deep/.el-table td {
  text-align: center;
}
</style>